import { Box, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { ExpandMoreIcon, QuizIcon } from "src/Pages/components/Icons/Icons";

import { ListFaq } from "./ListFaq";

export const Faq = () => {
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ mb: "16px" }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "500",
            textAlign: "center",
            mr: "12px",
          }}
        >
          Dúvidas frequentes
        </Typography>
        <QuizIcon sx={{ fontSize: "26px" }} />
      </Box>

      <Box>
        {ListFaq.map((item) => {
          return (
            <Accordion key={item.title} defaultExpanded={item.defaultExpanded}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                  fontSize: { xs: ".8rem", sm: ".9rem", lg: "1rem" },
                }}
              >
                <Typography>{item.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ fontSize: "14px" }}>
                  {item.description}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
};
